import { FC } from 'react';
import { Box, ListIcon, ListItem, UnorderedList } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import SunshineTag from 'components/_core/SunshineTag';
import Text from 'components/_core/Text';
import { OnboardingPlanDisplay } from 'features/Onboarding/modules/StepsPricingPlan/pages/PlanSelection/types';

import bulletPointsBuilders from './bulletPointsBuilders';
import locales from './locales';

interface BulletPointsProps {
  isMultiKYC: boolean;
  plan: OnboardingPlanDisplay;
}

export interface ProConItem {
  text: string;
  isNewFeature?: boolean;
  isComing?: boolean;
}

const BulletPoints: FC<BulletPointsProps> = ({ plan }) => {
  let list = [] as ProConItem[];

  list = bulletPointsBuilders[plan.providerPlanId](plan);

  return (
    <>
      <UnorderedList
        key={plan.providerPlanId}
        listStyleType="none"
        margin={0}
        padding={0}
      >
        {list.map((item) => (
          <ListItem
            alignItems="center"
            display="flex"
            justifyContent="space-between"
            key={item.text}
            marginBottom="space-16"
            paddingX="space-16"
          >
            <Box alignItems="start" display="flex">
              <ListIcon
                as={SunshineIcon}
                color="grey.800"
                marginRight="space-16"
                marginTop="space-4"
                name="tick"
              />
              <Text>{item.text}</Text>
              {item.isNewFeature ? (
                <SunshineTag colorScheme="green" size="sm">
                  {locales.new.toUpperCase()}
                </SunshineTag>
              ) : null}
              {item.isComing ? (
                <SunshineTag colorScheme="blue" flexShrink={0} size="sm">
                  {locales.isComing.toUpperCase()}
                </SunshineTag>
              ) : null}
            </Box>
          </ListItem>
        ))}
      </UnorderedList>
    </>
  );
};

export default BulletPoints;
